import asthaImg from '../assets/tekke-Astha.jpeg';
import athaniImg from '../assets/tekke-Athani.jpeg';
import solapurImg from '../assets/tekke-solapur.jpeg';

export const branches = [
  {
    slug: "astha",
    name: "Sree Teke Eye Clinic, Astha",
    title: "ASTHA",
    city: "Astha",
    area: "Astha",
    address: "Near by Rukade Petrol Pump, Swagat Hotel, 1st floor, Main Road, Astha",
    phone: "+91 99232 42655",
    phones: ["+91 99232 42655", "+91 70835 92101"],
    contactNumbers: "9923242655, 7083592101",
    whatsapp: "+91 99232 42655",
    timings: "Mon-Sat: 9:00 AM - 8:00 PM | Sun: 9:00 AM - 1:00 PM",
    mapUrl: "https://www.google.com/maps/search/?api=1&query=Sree+Teke+Eye+Clinic+Astha",
    doctors: ["dr-ramakant-tekke", "dr-vishakha-tekke"],
    facilities: ["Advanced Eye OPD", "Optical Store", "Cataract Evaluation", "Computerized Vision Check"],
    image: asthaImg
  },
  {
    slug: "jath",
    name: "Sree Teke Eye Clinic, Jath",
    title: "JATH",
    city: "Jath",
    area: "Jath",
    address: "Near by Rukade Petrol Jal wadi complex, Jath",
    phone: "+91 99232 42755",
    phones: ["+91 99232 42755", "+91 70835 92101"],
    contactNumbers: "9923242755, 7083592101",
    whatsapp: "+91 99232 42755",
    timings: "Mon-Sat: 9:30 AM - 7:30 PM | Sun: 9:30 AM - 1:30 PM",
    mapUrl: "https://www.google.com/maps/search/?api=1&query=Sree+Teke+Eye+Clinic+Jath",
    doctors: ["dr-ramakant-tekke", "dr-vishakha-tekke"],
    facilities: ["Consultation Rooms", "Optical Center", "Refraction Testing", "Pharmacy"],
    image: "https://images.unsplash.com/photo-1538108149393-fbbd81895907?auto=format&fit=crop&q=80&w=800"
  },
  {
    slug: "atpadi",
    name: "Sree Teke Eye Clinic, Atpadi",
    title: "ATPADI",
    city: "Atpadi",
    area: "Atpadi",
    address: "Near by S.T. Stand, top of Roweat Hospital, Atpadi",
    phone: "+91 90284 96584",
    phones: ["+91 90284 96584", "+91 70835 92101"],
    contactNumbers: "9028496584, 7083592101",
    whatsapp: "+91 90284 96584",
    timings: "Mon-Sat: 10:00 AM - 7:00 PM | Sun: Closed",
    mapUrl: "https://www.google.com/maps/search/?api=1&query=Sree+Teke+Eye+Clinic+Atpadi",
    doctors: ["dr-ramakant-tekke"],
    facilities: ["Comprehensive Eye Care", "Optical Store", "Diagnostic Facilities"],
    image: "https://images.unsplash.com/photo-1579684385127-1ef15d508118?auto=format&fit=crop&q=80&w=800"
  },
  {
    slug: "solapur",
    name: "Raghvendra Sree Teke Eye Clinic, Solapur",
    title: "SOLAPUR",
    city: "Solapur",
    area: "Solapur",
    address: "Maji sainik nagar, Vijapur road, Solapur",
    phone: "+91 70301 19119",
    phones: ["+91 70301 19119", "+91 99161 08503"],
    contactNumbers: "7030119119, 9916108503",
    whatsapp: "+91 70301 19119",
    timings: "Mon-Sat: 9:00 AM - 8:30 PM | Sun: 9:00 AM - 2:00 PM",
    mapUrl: "https://www.google.com/maps/search/?api=1&query=Raghvendra+Sree+Teke+Eye+Clinic+Solapur",
    doctors: ["dr-ramakant-tekke", "dr-vishakha-tekke"],
    facilities: ["Advanced Surgical Unit", "Laser Treatment", "Optical Store", "Diagnostic Center"],
    image: solapurImg
  },
  {
    slug: "athani",
    name: "Sree Teke Eye Clinic, Athani",
    title: "ATHANI",
    city: "Athani",
    area: "Athani",
    address: "Shantinagar Halyal Crucial Road, Athani",
    phone: "+91 98441 22001",
    phones: ["+91 98441 22001", "+91 96205 22001"],
    contactNumbers: "9844122001, 9620522001",
    whatsapp: "+91 98441 22001",
    timings: "Mon-Sat: 9:30 AM - 7:30 PM | Sun: 10:00 AM - 1:00 PM",
    mapUrl: "https://www.google.com/maps/search/?api=1&query=Sree+Teke+Eye+Clinic+Athani",
    doctors: ["dr-vishakha-tekke"],
    facilities: ["Consultation Rooms", "Optical Store", "Pediatric Eye Check"],
    image: athaniImg
  },
  {
    slug: "sangola",
    name: "Sree Teke Eye Clinic, Sangola",
    title: "SANGOLA",
    city: "Sangola",
    area: "Sangola",
    address: "Mauli Hights, Miraj road, Near Gauri Patrol Pump, Sangola",
    phone: "+91 99161 08116",
    phones: ["+91 99161 08116", "+91 99161 08152", "+91 70301 19119"],
    contactNumbers: "9916108116, 9916108152, 7030119119",
    whatsapp: "+91 99161 08116",
    timings: "Mon-Sat: 9:00 AM - 8:00 PM | Sun: 9:00 AM - 2:00 PM",
    mapUrl: "https://www.google.com/maps/search/?api=1&query=Sree+Teke+Eye+Clinic+Sangola",
    doctors: ["dr-ramakant-tekke", "dr-vishakha-tekke"],
    facilities: ["Full Eye Checkup", "Optical Dispensing", "Pharmacy", "Minor OT"],
    image: "https://images.unsplash.com/photo-1629909613654-28e377c37b09?auto=format&fit=crop&q=80&w=800"
  }
];
